import type { FrontendDownloadFileHandle } from "src/api/generated/common/frontendDownloadFileHandle.ts";
import type { CustomFunctionUiActionExecutionResult } from "src/api/generated/erp/customFunctions/triggers/uiAction/customFunctionUiActionExecutionResult.ts";
import type { CustomFunctionUiActionMessage } from "src/api/generated/erp/customFunctions/triggers/uiAction/customFunctionUiActionMessage.ts";

interface CustomFunctionUiActionExecutionResultHandlers {
	downloadFile: (file: FrontendDownloadFileHandle) => void;
	openMessage: (message: CustomFunctionUiActionMessage) => void;
	refreshData?: () => Promise<unknown>;
	showBackgroundStarted: () => void;
	refreshBackgroundOperations: () => Promise<unknown>;
}

export async function handleCustomFunctionUiActionExecutionResult(
	result: CustomFunctionUiActionExecutionResult,
	handlers: CustomFunctionUiActionExecutionResultHandlers,
) {
	if (result.operationId != null) {
		handlers.showBackgroundStarted();
		await handlers.refreshBackgroundOperations();
	}
	if (result.resultHandlings.includes("SHOW_MESSAGE") && result.message != null) {
		handlers.openMessage(result.message);
	}
	if (result.resultHandlings.includes("DOWNLOAD_FILES")) {
		for (const file of result.files) handlers.downloadFile(file);
	}
	if (result.resultHandlings.includes("REFRESH_DATA")) {
		await handlers.refreshData?.();
	}
}
